import { render, staticRenderFns } from "./discount-code.vue?vue&type=template&id=2c3bcace"
import script from "./discount-code.vue?vue&type=script&lang=js"
export * from "./discount-code.vue?vue&type=script&lang=js"
import style0 from "./discount-code.vue?vue&type=style&index=0&id=2c3bcace&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c3bcace')) {
      api.createRecord('2c3bcace', component.options)
    } else {
      api.reload('2c3bcace', component.options)
    }
    module.hot.accept("./discount-code.vue?vue&type=template&id=2c3bcace", function () {
      api.rerender('2c3bcace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/discount-code.vue"
export default component.exports